module.exports = __webpack_public_path__ + "img/pool.67855e4f.png";